const CONSTANTS = {
    AUCTION_COMPANY: 'AUCTION_COMPANY',
    NOT_MEMBER: 'NOT_MEMBER',
    CAN_NOT_BID: 'CAN_NOT_BID',
    CAN_BID: 'CAN_BID',
};

export default CONSTANTS;
